var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9823 14.7965C31.6991 13.7345 30.8673 12.9027 29.823 12.6195C27.9115 12.1062 20.2832 12.1062 20.2832 12.1062C20.2832 12.1062 12.6372 12.1062 10.7434 12.6195C9.69912 12.9027 8.86726 13.7345 8.58408 14.7965C8.0708 16.708 8.0708 20.708 8.0708 20.708C8.0708 20.708 8.0708 24.708 8.58408 26.6195C8.86726 27.6814 9.69912 28.5133 10.7434 28.7965C12.6549 29.3097 20.2832 29.3097 20.2832 29.3097C20.2832 29.3097 27.9292 29.3097 29.823 28.7965C30.8673 28.5133 31.6991 27.6814 31.9823 26.6195C32.4956 24.708 32.4956 20.708 32.4956 20.708C32.4956 20.708 32.4956 16.708 31.9823 14.7965ZM17.7876 24.3363V17.0796L24.177 20.708L17.7876 24.3363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9469 2.0177H6.0531C3.8244 2.0177 2.0177 3.8244 2.0177 6.05309V33.9469C2.0177 36.1756 3.8244 37.9823 6.05309 37.9823H33.9469C36.1756 37.9823 37.9823 36.1756 37.9823 33.9469V6.0531C37.9823 3.82441 36.1756 2.0177 33.9469 2.0177ZM6.0531 0H33.9469C37.2899 0 40 2.71006 40 6.0531V33.9469C40 37.2899 37.2899 40 33.9469 40H6.05309C2.71006 40 0 37.2899 0 33.9469V6.05309C0 2.71006 2.71006 0 6.0531 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.7690265ae78af4d78b4ac689bbc08e68.svg";
export { ForwardRef as ReactComponent };